var getUnit = function (value) { return (value === 0 ? "0" : "".concat(value, "px")); };
export var getDimension = function (theme, size) {
    return typeof size === "number" ? getUnit(theme.constants.SIZE_SUB_UNIT * size) : "auto";
};
export var getDimensions = function (theme, value) {
    return value.map(function (size) { return getDimension(theme, size); }).join(" ");
};
export default (function (_a) {
    var theme = _a.theme, margin = _a.margin;
    if (!margin)
        return "";
    if (Array.isArray(margin) && margin.length >= 1 && margin.length <= 4) {
        return "margin: ".concat(getDimensions(theme, margin), ";");
    }
    // eslint-disable-next-line no-console
    console.error("Please provide an array (max 4 elements) for `margin` style helper.");
    return "";
});
